import { useFetchAllProductGroups } from '@@partner:graphql/query/productGroup/allProductGroups.gql'
import { NestedFilter } from '@@partner:types:graphql'
import { renderLazyPickerMenu } from '@components/common/pickers'
import React, { useState } from 'react'
import { CheckPicker, SelectPicker } from 'rsuite'
import { TypeAttributes } from 'rsuite/esm/@types/common'

const defaultGroupFilter: NestedFilter = {
  fields: [ 'name' ],
  op: 'unwrap'
}

type MultipleSelector = {
  value: string[]
  onChange: (value: string[]) => void
  multiple: true
}

type SingleSelector = {
  value: string | undefined
  onChange: (value: string) => void
  multiple?: false
}

type props = {
  placeholder?: string
  menuStyle?: React.CSSProperties
  placement?: TypeAttributes.Placement
} & (SingleSelector | MultipleSelector)

export default function ProductGroupSelector <T extends boolean> ({
  value, 
  onChange,
  multiple,
  placeholder,
  menuStyle,
  placement
}: props) {

  const [ page, setPage ] = useState(1)
  const [ filter, setFilter ] = useState<NestedFilter>(defaultGroupFilter)

  const handleSearchByName = (text: string) => {
    setFilter({
      or: [
        {
          fields: [ 'name' ],
          op: 'starts_with',
          value: [ text ]
        }
      ]
    })
  }

  const { 
    data, 
    loading, 
    error 
  } = useFetchAllProductGroups({
    pager: { page }, 
    sort: {  fieldName: 'name', direction: 0 }, 
    filter
  })


  const productGroups = data?.allProductGroups.edges.map(group => ({
    label: group.name,
    value: `${group.id}`
  })) ?? []
  
  if (multiple) {
    return (
      <CheckPicker
        placeholder={placeholder ?? 'Выберите группы'}
        data={productGroups}
        value={value}
        onChange={onChange}
        onSearch={handleSearchByName}
        renderMenu={renderLazyPickerMenu(loading, data)}
        style={{ width: 224, zIndex: 9999 }}
        menuStyle={menuStyle}
      />
    )
  }
  
  if (!multiple) {
    return (
      <SelectPicker
        placement={placement}
        data={productGroups}
        value={value}
        onChange={onChange}
        onSearch={handleSearchByName}
        renderMenu={renderLazyPickerMenu(loading, data)}
        placeholder={ placeholder ?? 'Добавить в группу'}
        style={{ width: 224, zIndex: 9999 }}
        menuStyle={menuStyle}
      />
    )
  }

  return <></>
}